import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  FormControl,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_sales_order_editor_ComponentContextService } from './FootprintManager.sales_order_editor.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_sales_order_lines_gridComponent } from './FootprintManager.sales_order_lines_grid.component';
import { FootprintManager_sales_order_picking_gridComponent } from './FootprintManager.sales_order_picking_grid.component';
import { FootprintManager_manual_allocations_gridComponent } from './FootprintManager.manual_allocations_grid.component';
import { FootprintManager_shippingcontents_gridComponent } from './FootprintManager.shippingcontents_grid.component';
import { SalesOrders_outbound_bill_of_lading_reportComponent } from './SalesOrders.outbound_bill_of_lading_report.component';
import { SalesOrders_pick_slip_by_orderId_reportComponent } from './SalesOrders.pick_slip_by_orderId_report.component';
import { FootprintManager_accessorial_tasks_gridComponent } from './FootprintManager.accessorial_tasks_grid.component';
import { FootprintManager_billing_records_gridComponent } from './FootprintManager.billing_records_grid.component';
import { FootprintManager_orderaddresses_gridComponent } from './FootprintManager.orderaddresses_grid.component';
import { FootprintManager_sales_order_tasks_gridComponent } from './FootprintManager.sales_order_tasks_grid.component';
import { SalesOrders_order_total_units_widgetComponent } from './SalesOrders.order_total_units_widget.component';
import { SalesOrders_order_total_picked_units_widgetComponent } from './SalesOrders.order_total_picked_units_widget.component';
import { SalesOrders_order_total_picked_gross_widgetComponent } from './SalesOrders.order_total_picked_gross_widget.component';
import { SalesOrders_orderclasses_dd_singleComponent } from './SalesOrders.orderclasses_dd_single.component'
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Locations_warehouses_dd_singleComponent } from './Locations.warehouses_dd_single.component'
import { Carriers_carriers_ownerscarriers_dd_singleComponent } from './Carriers.carriers_ownerscarriers_dd_single.component'
import { Carriers_carrierservicetype_dd_singleComponent } from './Carriers.carrierservicetype_dd_single.component'
import { SalesOrders_shipment_payment_term_dd_singleComponent } from './SalesOrders.shipment_payment_term_dd_single.component'

type EntityType = { 
    Id?: number, AccountId?: number, BillingAddresId?: number, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredCarrierId?: number, PreferredCarrierServiceTypeId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { OwnerId?: number }, OrderClass?: { AllowInactiveInventory?: boolean, Name?: string }, Status?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, BillOfLading?: string, BrokerReference?: string, CarrierId?: number, CarrierServiceTypeId?: number, ContainerIdentifier?: string, ConveyanceId?: number, ConveyenceReference?: string, DeliveredDate?: string, ExpectedDate?: string, LoadContainerId?: number, LookupCode?: string, Notes?: string, PaymentTermId?: number, PickupDate?: string, ReferenceNumber?: string, SealId?: string, TrackingIdentifier?: string, TrailerId?: string } }[], OrderLines?: { LineNumber?: number }[], Account?: { Id?: number, AccountsContactsLookup?: { ContactId?: number, Contact?: { FirstName?: string, LastName?: string, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }}; 

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_sales_order_lines_gridComponent),
    forwardRef(() => FootprintManager_sales_order_picking_gridComponent),
    forwardRef(() => FootprintManager_manual_allocations_gridComponent),
    forwardRef(() => FootprintManager_shippingcontents_gridComponent),
    forwardRef(() => SalesOrders_outbound_bill_of_lading_reportComponent),
    forwardRef(() => SalesOrders_pick_slip_by_orderId_reportComponent),
    forwardRef(() => FootprintManager_accessorial_tasks_gridComponent),
    forwardRef(() => FootprintManager_billing_records_gridComponent),
    forwardRef(() => FootprintManager_orderaddresses_gridComponent),
    forwardRef(() => FootprintManager_sales_order_tasks_gridComponent),
    forwardRef(() => SalesOrders_order_total_units_widgetComponent),
    forwardRef(() => SalesOrders_order_total_picked_units_widgetComponent),
    forwardRef(() => SalesOrders_order_total_picked_gross_widgetComponent),
    forwardRef(() => SalesOrders_orderclasses_dd_singleComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Locations_warehouses_dd_singleComponent),
    forwardRef(() => Carriers_carriers_ownerscarriers_dd_singleComponent),
    forwardRef(() => Carriers_carrierservicetype_dd_singleComponent),
    forwardRef(() => SalesOrders_shipment_payment_term_dd_singleComponent),
  ],
  selector: 'FootprintManager-sales_order_editor',
  templateUrl: './FootprintManager.sales_order_editor.component.html'
})
export class FootprintManager_sales_order_editorComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
  inParams: { orderId: number } = { orderId: null };
  //#region Inputs
  @Input('orderId') set $inParams_orderId(v: number) {
    this.inParams.orderId = v;
  }
  get $inParams_orderId(): number {
    return this.inParams.orderId;
  }
  //#endregion Inputs

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { shipmentId?: number, billingAddressId?: number, orderState?: number, is_edi?: boolean } = { };
  //#endregion
  entity: EntityType;

  formGroup: FormGroup = new FormGroup({
    lookupcode: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    order_class: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    owner: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    warehouse: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    carrier: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    carrier_service: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    container_identifier: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    bill_of_lading: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    trailer: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    seal: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    tracking: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    expected_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    reference: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    vendor_reference: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    requested_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    pickup_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    payment_term: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    shipment_carrier: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    shipment_carrier_service: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    shipment_notes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    notes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  get valid(): boolean {
    return this.formGroup.valid;
  }

  toolbar = {
      process: new ToolModel(new ButtonModel('process', new ButtonStyles(['primary'], null), false, false, false, 'Process', 'icon-ic_fluent_arrow_clockwise_dashes_20_regular', null)
    , false),
      complete: new ToolModel(new ButtonModel('complete', new ButtonStyles(['primary'], null), false, false, false, 'Complete', 'icon-ic_fluent_checkmark_circle_20_regular', null)
    , false),
      auto_pick: new ToolModel(new ButtonModel('auto_pick', new ButtonStyles(['primary'], null), false, false, false, 'Auto pick', 'icon-datex-Pick', null)
    , false),
      auto_load: new ToolModel(new ButtonModel('auto_load', new ButtonStyles(['primary'], null), false, false, false, 'Auto load', 'icon-datex-Load', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      appointment: new ToolModel(new ButtonModel('appointment', new ButtonStyles(null, null), false, false, false, 'Schedule appointment', 'icon-ic_fluent_calendar_add_20_regular', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      revert: new ToolModel(new ButtonModel('revert', new ButtonStyles(null, null), false, false, false, 'Revert status', 'ms-Icon ms-Icon--ClearSelection', null)
    , false),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(null, null), false, false, false, 'Cancel', 'icon-ic_fluent_dismiss_circle_20_regular', null)
    , false),
      on_delete: new ToolModel(new ButtonModel('on_delete', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      separator3: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      attachments: new ToolModel(new ButtonModel('attachments', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_attach_20_regular', () => { const $utils = this.$utils; const $editor = this; return 'Attachments'; })
    , false),
      discussions: new ToolModel(new ButtonModel('discussions', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_chat_20_regular', () => { const $utils = this.$utils; const $editor = this; return 'Discussions'; })
    , false),
      prints: new ToolModel(new SplitButtonModel<{ license_plate_labels: ButtonModel, loadslip: ButtonModel }>(
        'prints',
        new ButtonStyles(null, null),
        false,
        false,
        ' ',
        'icon-ic_fluent_print_20_regular',
        () => { const $utils = this.$utils; const $editor = this; return 'Print'; },
        [
          new ButtonModel('license_plate_labels', new ButtonStyles(null, null), false, false, false, 'License plate labels', ''),
          new ButtonModel('loadslip', new ButtonStyles(null, null), false, false, false, 'Load slip report', '')
        ])
    , false),
      separator4: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      options: new ToolModel(new SplitButtonModel<{ email_requests: ButtonModel, driver_check_out: ButtonModel, pallet_transactions: ButtonModel, surveys: ButtonModel, temperature_readings: ButtonModel, copy_order: ButtonModel, convert_edi: ButtonModel, instructions: ButtonModel }>(
        'options',
        new ButtonStyles(null, null),
        false,
        false,
        ' ',
        'icon-ic_fluent_more_horizontal_20_regular',
        null,
        [
          new ButtonModel('email_requests', new ButtonStyles(null, null), false, false, false, 'Email requests', 'icon-ic_fluent_mail_arrow_up_20_regular'),
          new ButtonModel('driver_check_out', new ButtonStyles(null, null), false, false, false, 'Driver check out', 'ms-Icon ms-Icon--InsertSignatureLine'),
          new ButtonModel('pallet_transactions', new ButtonStyles(null, null), false, false, false, 'Pallet transactions', 'icon-ic_fluent_arrow_swap_20_regular'),
          new ButtonModel('surveys', new ButtonStyles(null, null), false, false, false, 'Surveys', 'icon-ic_fluent_shifts_availability_20_regular'),
          new ButtonModel('temperature_readings', new ButtonStyles(null, null), false, false, false, 'Temperature readings', 'ms-Icon ms-Icon--Frigid'),
          new ButtonModel('copy_order', new ButtonStyles(null, null), false, false, false, 'Copy order', 'ms-Icon ms-Icon--Copy'),
          new ButtonModel('convert_edi', new ButtonStyles(null, null), false, false, false, 'Convert to EDI order', 'icon-ic_fluent_convert_range_20_regular'),
          new ButtonModel('instructions', new ButtonStyles(null, null), false, false, false, 'Instructions', 'icon-ic_fluent_book_information_20_regular')
        ])
    , false),
      separator5: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false)
  };

  fields = {
    lookupcode: new FieldModel(new TextBoxModel(this.formGroup.controls['lookupcode'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Order code', true, false),
    order_class: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['order_class'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Order class', true, false),
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Owner', true, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', true, false),
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', true, false),
    order_status: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), 'Order status', false, false),
    order_state: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), 'Order state', false, false),
    custom_fields: new FieldModel(new ButtonModel('', new ButtonStyles(null, null), false, false, false, 'Custom fields', 'ms-Icon ms-Icon--Edit', null)
, new ControlContainerStyles(null, null), '', false, false),
    ship_to_selection: new FieldModel(new ButtonModel('', new ButtonStyles(['link'], null), false, false, false, 'Select shipping address', 'icon-ic_fluent_contact_card_20_regular', null)
, new ControlContainerStyles(null, null), '', false, false),
    select_shipping_address_separator: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), '', false, false),
    ship_to_clear: new FieldModel(new ButtonModel('', new ButtonStyles(null, null), false, false, false, 'Clear', 'ms-Icon ms-Icon--Blocked', null)
, new ControlContainerStyles(null, null), '', false, false),
    ship_to: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), '', false, false),
    carrier: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['carrier'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Carrier', false, false),
    carrier_service: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['carrier_service'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Carrier service', false, false),
    container_identifier: new FieldModel(new TextBoxModel(this.formGroup.controls['container_identifier'] as DatexFormControl, null, true, false, '', null)
, new ControlContainerStyles(null, null), 'Container identifier', false, false),
    bill_of_lading: new FieldModel(new TextBoxModel(this.formGroup.controls['bill_of_lading'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'BOL', false, false),
    trailer: new FieldModel(new TextBoxModel(this.formGroup.controls['trailer'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Trailer number', false, false),
    seal: new FieldModel(new TextBoxModel(this.formGroup.controls['seal'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Seal number', false, false),
    tracking: new FieldModel(new TextBoxModel(this.formGroup.controls['tracking'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Tracking', false, false),
    expected_date: new FieldModel(new DateBoxModel(this.formGroup.controls['expected_date'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Expected date', false, false),
    reference: new FieldModel(new TextBoxModel(this.formGroup.controls['reference'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Owner reference', false, false),
    vendor_reference: new FieldModel(new TextBoxModel(this.formGroup.controls['vendor_reference'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Vendor reference', false, false),
    requested_date: new FieldModel(new DateBoxModel(this.formGroup.controls['requested_date'] as DatexFormControl, null, false, false, 'MM/DD/YYYY', 'datetime', null)
, new ControlContainerStyles(null, null), 'Requested delivery date', false, false),
    pickup_date: new FieldModel(new DateBoxModel(this.formGroup.controls['pickup_date'] as DatexFormControl, null, false, false, 'MM/DD/YYYY', 'datetime', null)
, new ControlContainerStyles(null, null), 'Pickup date', false, false),
    payment_term: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['payment_term'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Payment term', false, false),
    shipment_carrier: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['shipment_carrier'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Shipment carrier', false, false),
    shipment_carrier_service: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['shipment_carrier_service'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Shipment carrier service', false, false),
    shipment_notes: new FieldModel(new TextBoxModel(this.formGroup.controls['shipment_notes'] as DatexFormControl, null, false, false, 'Shipment notes', null)
, new ControlContainerStyles(null, null), 'Shipment notes', false, false),
    integration_information: new FieldModel(new ButtonModel('', new ButtonStyles(['link'], null), false, false, false, 'Integration information', '', null)
, new ControlContainerStyles(null, null), 'Integration information', false, false),
    notes: new FieldModel(new TextBoxModel(this.formGroup.controls['notes'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), '  ', false, false),
  };

  fieldsets = {
    newGroup1: new FieldsetModel(
      '  ',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $editor = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    newGroup2: new FieldsetModel(
      'Shipping details',
      false,
      true,
      false,
      false,
        null
      ,
      () => {
        const $editor = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    additional_details: new FieldsetModel(
      'Additional Details',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $editor = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    notes: new FieldsetModel(
      'Notes',
      false,
      true,
      false,
      false,
        null
      ,
      () => {
        const $editor = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
      reports: new TabGroupModel(),
      billing: new TabGroupModel(),
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      sales_order_lines: new TabItemModel(
        this.rootTabGroup, 
        'Lines', 
        false,
        ),
      picking_tasks: new TabItemModel(
        this.rootTabGroup, 
        'Pick tasks', 
        false,
        ),
      manual_allocation_tasks: new TabItemModel(
        this.rootTabGroup, 
        'Manual tasks', 
        false,
        ),
      shipping_contents: new TabItemModel(
        this.rootTabGroup, 
        'Picked', 
        false,
        ),
      reports: new TabItemModel(
        this.rootTabGroup, 
        'Reports', 
        false,
        true,
        {
          bol_report: new TabItemModel(
          this.subTabGroups.reports, 
          'Bill of Lading', 
          false
          ),
          pick_slip_report: new TabItemModel(
          this.subTabGroups.reports, 
          'Pick Slip', 
          false
          ),
        }
        ),
      billing: new TabItemModel(
        this.rootTabGroup, 
        'Billing', 
        false,
        true,
        {
          accessorial_tasks: new TabItemModel(
          this.subTabGroups.billing, 
          'Accessorials', 
          false
          ),
          billing_records: new TabItemModel(
          this.subTabGroups.billing, 
          'Billing Records', 
          false
          ),
        }
        ),
      contacts: new TabItemModel(
        this.rootTabGroup, 
        'Contacts', 
        false,
        ),
      tasks: new TabItemModel(
        this.rootTabGroup, 
        'Activity', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ShipmentOrderLookups[0]?.ShipmentId;
      
      return expr;
    }
  
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_projectId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ProjectId;
      
      return expr;
    }
  
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_orderStatusId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.OrderStatusId;
      
      return expr;
    }
  
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_warehouseId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.PreferredWarehouseId;
      
      return expr;
    }
  
    get $tabs_sales_order_lines_sales_order_lines_grid_inParams_orderState(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.vars.orderState;
      
      return expr;
    }
  
    get $tabs_picking_tasks_sales_order_picking_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_picking_tasks_sales_order_picking_grid_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ShipmentOrderLookups[0]?.ShipmentId;
      
      return expr;
    }
  
    get $tabs_picking_tasks_sales_order_picking_grid_inParams_orderStatusId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.OrderStatusId;
      
      return expr;
    }
  
    get $tabs_manual_allocation_tasks_manual_allocations_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_manual_allocation_tasks_manual_allocations_grid_inParams_allowInactive(): boolean {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.OrderClass.AllowInactiveInventory;
      
      return expr;
    }
  
    get $tabs_shipping_contents_shippingcontents_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_shipping_contents_shippingcontents_grid_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.vars.shipmentId;
      
      return expr;
    }
  
    get $tabs_reports_bol_report_outbound_bill_of_lading_report_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_reports_pick_slip_report_pick_slip_by_orderId_report_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_billing_accessorial_tasks_accessorial_tasks_grid_inParams_projectId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ProjectId;
      
      return expr;
    }
  
    get $tabs_billing_accessorial_tasks_accessorial_tasks_grid_inParams_entityStatusId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.OrderStatusId;
      
      return expr;
    }
  
    get $tabs_billing_accessorial_tasks_accessorial_tasks_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_billing_accessorial_tasks_accessorial_tasks_grid_inParams_warehouseId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.PreferredWarehouseId;
      
      return expr;
    }
  
    get $tabs_billing_accessorial_tasks_accessorial_tasks_grid_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ShipmentOrderLookups[0]?.ShipmentId;
      
      return expr;
    }
  
    cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_orderIds: number[];
    get $tabs_billing_billing_records_billing_records_grid_inParams_orderIds(): number[] {
      const $editor = this;
      const $utils = this.$utils;
      const expr = [$editor.inParams.orderId];
      
      if(!isEqual(this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_orderIds, expr)) {
        this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_orderIds = expr;
      }
      return this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_orderIds;
    }
  
    get $tabs_billing_billing_records_billing_records_grid_inParams_includeInvoiced(): boolean {
      const $editor = this;
      const $utils = this.$utils;
      const expr = true;
      
      return expr;
    }
  
    cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_shipmentIds: number[];
    get $tabs_billing_billing_records_billing_records_grid_inParams_shipmentIds(): number[] {
      const $editor = this;
      const $utils = this.$utils;
      const expr = [$editor.entity.ShipmentOrderLookups[0]?.ShipmentId];
      
      if(!isEqual(this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_shipmentIds, expr)) {
        this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_shipmentIds = expr;
      }
      return this.cacheValueFor_$tabs_billing_billing_records_billing_records_grid_inParams_shipmentIds;
    }
  
    get $tabs_contacts_orderaddresses_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_tasks_sales_order_tasks_grid_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $tabs_tasks_sales_order_tasks_grid_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.entity.ShipmentOrderLookups[0]?.ShipmentId;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_sales_order_lines', { read: FootprintManager_sales_order_lines_gridComponent }) $tabs_sales_order_lines: FootprintManager_sales_order_lines_gridComponent;
      @ViewChild('$tabs_picking_tasks', { read: FootprintManager_sales_order_picking_gridComponent }) $tabs_picking_tasks: FootprintManager_sales_order_picking_gridComponent;
      @ViewChild('$tabs_manual_allocation_tasks', { read: FootprintManager_manual_allocations_gridComponent }) $tabs_manual_allocation_tasks: FootprintManager_manual_allocations_gridComponent;
      @ViewChild('$tabs_shipping_contents', { read: FootprintManager_shippingcontents_gridComponent }) $tabs_shipping_contents: FootprintManager_shippingcontents_gridComponent;
        @ViewChild('$tabs_reports_bol_report', { read: SalesOrders_outbound_bill_of_lading_reportComponent }) $tabs_reports_bol_report: SalesOrders_outbound_bill_of_lading_reportComponent;
        @ViewChild('$tabs_reports_pick_slip_report', { read: SalesOrders_pick_slip_by_orderId_reportComponent }) $tabs_reports_pick_slip_report: SalesOrders_pick_slip_by_orderId_reportComponent;
        @ViewChild('$tabs_billing_accessorial_tasks', { read: FootprintManager_accessorial_tasks_gridComponent }) $tabs_billing_accessorial_tasks: FootprintManager_accessorial_tasks_gridComponent;
        @ViewChild('$tabs_billing_billing_records', { read: FootprintManager_billing_records_gridComponent }) $tabs_billing_billing_records: FootprintManager_billing_records_gridComponent;
      @ViewChild('$tabs_contacts', { read: FootprintManager_orderaddresses_gridComponent }) $tabs_contacts: FootprintManager_orderaddresses_gridComponent;
      @ViewChild('$tabs_tasks', { read: FootprintManager_sales_order_tasks_gridComponent }) $tabs_tasks: FootprintManager_sales_order_tasks_gridComponent;
    //#endregion tabs children
    widgets = {
      order_total_units_widget: new WidgetModel(false),
      order_total_picked_units_widget: new WidgetModel(false),
      order_total_picked_gross_widget: new WidgetModel(false),
    };
  
    //#region widgets inParams
    get $widgets_order_total_units_widget_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $widgets_order_total_picked_units_widget_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $widgets_order_total_picked_units_widget_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.vars.shipmentId;
      
      return expr;
    }
  
    get $widgets_order_total_picked_gross_widget_inParams_orderId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.inParams.orderId;
      
      return expr;
    }
  
    get $widgets_order_total_picked_gross_widget_inParams_shipmentId(): number {
      const $editor = this;
      const $utils = this.$utils;
      const expr = $editor.vars.shipmentId;
      
      return expr;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_order_total_units_widget', { read:  SalesOrders_order_total_units_widgetComponent }) $widgets_order_total_units_widget: SalesOrders_order_total_units_widgetComponent;
      @ViewChild('$widgets_order_total_picked_units_widget', { read:  SalesOrders_order_total_picked_units_widgetComponent }) $widgets_order_total_picked_units_widget: SalesOrders_order_total_picked_units_widgetComponent;
      @ViewChild('$widgets_order_total_picked_gross_widget', { read:  SalesOrders_order_total_picked_gross_widgetComponent }) $widgets_order_total_picked_gross_widget: SalesOrders_order_total_picked_gross_widgetComponent;
    //#endregion widgets children

  //#region fields inParams
  get $fields_owner_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = 1;
    
    return expr;
  }

  get $fields_owner_selector_inParams_projectId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.fields.project.control.value;
    
    return expr;
  }

  get $fields_project_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = 1;
    
    return expr;
  }

  get $fields_project_selector_inParams_ownerId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.fields.owner.control.value;
    
    return expr;
  }

  get $fields_carrier_selector_inParams_ownerId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.entity.Project.OwnerId;
    
    return expr;
  }

  get $fields_carrier_service_selector_inParams_carrierId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.fields.carrier.control.value;
    
    return expr;
  }

  get $fields_payment_term_selector_inParams_shipment_payment_term_id(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.entity.ShipmentOrderLookups[0]?.Shipment?.PaymentTermId;
    
    return expr;
  }

  get $fields_shipment_carrier_selector_inParams_ownerId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.entity.Project.OwnerId;
    
    return expr;
  }

  get $fields_shipment_carrier_service_selector_inParams_carrierId(): number {
    if (!this.entity) return null; 
    const $editor = this;
    const $utils = this.$utils;
    const expr = $editor.entity.ShipmentOrderLookups[0]?.Shipment?.CarrierId;
    
    return expr;
  }

  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    lookupcode: this.fields.lookupcode.control.valueChanges
    ,
    order_class: this.fields.order_class.control.valueChanges
    ,
    owner: this.fields.owner.control.valueChanges
    ,
    project: this.fields.project.control.valueChanges
    ,
    warehouse: this.fields.warehouse.control.valueChanges
    ,
    carrier: this.fields.carrier.control.valueChanges
    ,
    carrier_service: this.fields.carrier_service.control.valueChanges
    ,
    container_identifier: this.fields.container_identifier.control.valueChanges
    ,
    bill_of_lading: this.fields.bill_of_lading.control.valueChanges
    ,
    trailer: this.fields.trailer.control.valueChanges
    ,
    seal: this.fields.seal.control.valueChanges
    ,
    tracking: this.fields.tracking.control.valueChanges
    ,
    expected_date: this.fields.expected_date.control.valueChanges
    ,
    reference: this.fields.reference.control.valueChanges
    ,
    vendor_reference: this.fields.vendor_reference.control.valueChanges
    ,
    requested_date: this.fields.requested_date.control.valueChanges
    ,
    pickup_date: this.fields.pickup_date.control.valueChanges
    ,
    payment_term: this.fields.payment_term.control.valueChanges
    ,
    shipment_carrier: this.fields.shipment_carrier.control.valueChanges
    ,
    shipment_carrier_service: this.fields.shipment_carrier_service.control.valueChanges
    ,
    shipment_notes: this.fields.shipment_notes.control.valueChanges
    ,
    notes: this.fields.notes.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_sales_order_editor_ComponentContextService,
    ) { 
    super();
    this.$subscribeFormControlValueChanges();
    
    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.sales_order_lines,
      this.tabs.picking_tasks,
      this.tabs.manual_allocation_tasks,
      this.tabs.shipping_contents,
      this.tabs.reports,
      this.tabs.billing,
      this.tabs.contacts,
      this.tabs.tasks,
    ]; 
    this.subTabGroups.reports.tabs = [
        this.tabs.reports.tabs.bol_report,
        this.tabs.reports.tabs.pick_slip_report,
    ];    
    this.subTabGroups.billing.tabs = [
        this.tabs.billing.tabs.accessorial_tasks,
        this.tabs.billing.tabs.billing_records,
    ];    
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.orderId)) {
        this.$missingRequiredInParams.push('orderId');
      }
  }

  initialized = false;

  $hasDataLoaded = false;

  async $init() {
    this.title = 'Edit sales order';
    
    await this.on_init();

    await this.$dataLoad();
    this.initialized = true;
  }

  async $dataLoad() {
    const $editor = this;
    const $utils = this.$utils;

    const dsParams = {
      orderId:  $editor.inParams.orderId 
    };

    const data = await this.$datasources.SalesOrders.ds_sales_order_editor.get(dsParams);

    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;

      await this.$applyLinkedDatasourcesAndCustomColumns(dsParams, data);
      
      this.entity = data.result as EntityType;

      await this.$dataLoaded();
    }
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  async $dataLoaded() {
    const $editor = this;
    const $utils = this.$utils;
   
    (this.fields.lookupcode.control as TextBoxModel).reset($editor.entity.LookupCode);
    (this.fields.order_class.control as SelectBoxModel).reset($editor.entity.OrderClassId);
    (this.fields.owner.control as SelectBoxModel).reset($editor.entity.Project.OwnerId);
    (this.fields.project.control as SelectBoxModel).reset($editor.entity.ProjectId);
    (this.fields.warehouse.control as SelectBoxModel).reset($editor.entity.PreferredWarehouseId);
    (this.fields.order_status.control as TextModel).text = $editor.entity.Status.Name;
    (this.fields.carrier.control as SelectBoxModel).reset($editor.entity.PreferredCarrierId);
    (this.fields.carrier_service.control as SelectBoxModel).reset($editor.entity.PreferredCarrierServiceTypeId);
    (this.fields.container_identifier.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.ContainerIdentifier);
    (this.fields.bill_of_lading.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.BillOfLading);
    (this.fields.trailer.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.TrailerId);
    (this.fields.seal.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.SealId);
    (this.fields.tracking.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.TrackingIdentifier);
    (this.fields.expected_date.control as DateBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedDate);
    (this.fields.reference.control as TextBoxModel).reset($editor.entity.OwnerReference);
    (this.fields.vendor_reference.control as TextBoxModel).reset($editor.entity.VendorReference);
    (this.fields.requested_date.control as DateBoxModel).reset($editor.entity.RequestedDeliveryDate);
    (this.fields.pickup_date.control as DateBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.PickupDate?.toString());
    (this.fields.payment_term.control as SelectBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.PaymentTermId);
    (this.fields.shipment_carrier.control as SelectBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.CarrierId);
    (this.fields.shipment_carrier_service.control as SelectBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.CarrierServiceTypeId);
    (this.fields.shipment_notes.control as TextBoxModel).reset($editor.entity.ShipmentOrderLookups[0]?.Shipment?.Notes);
    (this.fields.notes.control as TextBoxModel).reset($editor.entity.Notes);

    await this.on_data_loaded();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_order_total_units_widget') {
      if (!isNil(this.$widgets_order_total_units_widget) && !this.widgets.order_total_units_widget.hidden && !this.widgets.order_total_units_widget.removed) {
        this.$widgets_order_total_units_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_order_total_picked_units_widget') {
      if (!isNil(this.$widgets_order_total_picked_units_widget) && !this.widgets.order_total_picked_units_widget.hidden && !this.widgets.order_total_picked_units_widget.removed) {
        this.$widgets_order_total_picked_units_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_order_total_picked_gross_widget') {
      if (!isNil(this.$widgets_order_total_picked_gross_widget) && !this.widgets.order_total_picked_gross_widget.hidden && !this.widgets.order_total_picked_gross_widget.removed) {
        this.$widgets_order_total_picked_gross_widget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
      if (childToSkip !== '$tabs_sales_order_lines') {
        if (!isNil(this.$tabs_sales_order_lines) && !this.tabs.sales_order_lines.hidden && !this.tabs.sales_order_lines.removed) {
          this.$tabs_sales_order_lines.refresh(true, false, null);
        }
      }    
      if (childToSkip !== '$tabs_picking_tasks') {
        if (!isNil(this.$tabs_picking_tasks) && !this.tabs.picking_tasks.hidden && !this.tabs.picking_tasks.removed) {
          this.$tabs_picking_tasks.refresh(true, false, null);
        }
      }    
      if (childToSkip !== '$tabs_manual_allocation_tasks') {
        if (!isNil(this.$tabs_manual_allocation_tasks) && !this.tabs.manual_allocation_tasks.hidden && !this.tabs.manual_allocation_tasks.removed) {
          this.$tabs_manual_allocation_tasks.refresh(true, false, null);
        }
      }    
      if (childToSkip !== '$tabs_shipping_contents') {
        if (!isNil(this.$tabs_shipping_contents) && !this.tabs.shipping_contents.hidden && !this.tabs.shipping_contents.removed) {
          this.$tabs_shipping_contents.refresh(true, false, null);
        }
      }    
      if (childToSkip !== '$tabs_reports_bol_report') {
        if (!isNil(this.$tabs_reports_bol_report) && !this.tabs.reports.tabs.bol_report.hidden && !this.tabs.reports.tabs.bol_report.removed) {
          this.$tabs_reports_bol_report.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_reports_pick_slip_report') {
        if (!isNil(this.$tabs_reports_pick_slip_report) && !this.tabs.reports.tabs.pick_slip_report.hidden && !this.tabs.reports.tabs.pick_slip_report.removed) {
          this.$tabs_reports_pick_slip_report.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_billing_accessorial_tasks') {
        if (!isNil(this.$tabs_billing_accessorial_tasks) && !this.tabs.billing.tabs.accessorial_tasks.hidden && !this.tabs.billing.tabs.accessorial_tasks.removed) {
          this.$tabs_billing_accessorial_tasks.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_billing_billing_records') {
        if (!isNil(this.$tabs_billing_billing_records) && !this.tabs.billing.tabs.billing_records.hidden && !this.tabs.billing.tabs.billing_records.removed) {
          this.$tabs_billing_billing_records.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_contacts') {
        if (!isNil(this.$tabs_contacts) && !this.tabs.contacts.hidden && !this.tabs.contacts.removed) {
          this.$tabs_contacts.refresh(true, false, null);
        }
      }    
      if (childToSkip !== '$tabs_tasks') {
        if (!isNil(this.$tabs_tasks) && !this.tabs.tasks.hidden && !this.tabs.tasks.removed) {
          this.$tabs_tasks.refresh(true, false, null);
        }
      }    
    //#endregion tabs children
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
  
  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .lookupcode
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .order_class
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .owner
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_changed();
      });
    this.$formGroupFieldValidationObservables
      .project
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .warehouse
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .carrier
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .carrier_service
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .container_identifier
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .bill_of_lading
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .trailer
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .seal
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .tracking
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .expected_date
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .reference
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .vendor_reference
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .requested_date
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .pickup_date
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .payment_term
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .shipment_carrier
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .shipment_carrier_service
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .shipment_notes
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
    this.$formGroupFieldValidationObservables
      .notes
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_save();
      });
  }

  //#region private flows
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const result = await $flows.SalesOrders.is_sales_order_deletable_flow({ orderId: $editor.entity.Id });
  const reason = result.reason;
  if ($utils.isDefined(reason)) {
      await $shell.FootprintManager.openErrorDialog('Order cannot be deleted.', reason);
      return;
  } else {
      const confirm = await $shell.FootprintManager.openConfirmationDialog(`Delete order ${$editor.entity.LookupCode}?`, '', 'Delete order', 'Cancel');
      if (confirm) {
          try {
              const orderLookup = $editor.entity.LookupCode;
              const result = await $flows.SalesOrders.delete_sales_order_flow({ orderId: $editor.entity.Id });
              const reason = result.reason;
  
              if ($utils.isDefined(reason)) {
                  await $shell.FootprintManager.openErrorDialog('Order cannot be deleted.', reason);
                  return;
              }
              else {
                  const title = `Order ${orderLookup} deleted`
                  $shell.FootprintManager.openToaster(title,'',EToasterType.Success,{closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight});
                  $editor.close();
              }
          } catch (error) {
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
              await $shell.FootprintManager.openErrorDialog('Order delete error', 'An error occurred during the deletion of the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
          }
      }
  }
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  var shipmentId = $editor.entity.ShipmentOrderLookups[0]?.ShipmentId;
  var orderId = $editor.inParams.orderId;
  var orderStatusId = $editor.entity.OrderStatusId;
  
  if ($utils.isDefined(shipmentId)) {
  
      const result = await $flows.SalesOrders.is_sales_order_cancelable_flow({ 
          orderId: $editor.entity.Id, 
          shipmentId: $editor.entity.ShipmentOrderLookups[0]?.ShipmentId });
      const reason = result.reason;
      if ($utils.isDefined(reason)) {
          await $shell.FootprintManager.openErrorDialog('Order cannot be canceled.', reason);
          return;
      } else {
          const confirm = await $shell.FootprintManager.openConfirmationDialog(`Cancel order ${$editor.entity.LookupCode}?`, '', 'Cancel order', 'Keep order');
          if (confirm) {
              try {
  
                  if (orderStatusId === 1) {
  
                      const result = await $flows.SalesOrders.cancel_sales_order_flow({
                          orderId: orderId
                      });
                      const reason = result.reason;
  
                      if ($utils.isDefined(reason)) {
                          await $shell.FootprintManager.openErrorDialog('Order cannot be cancelled.', reason);
                          return;
                      }
                      else {
  
                              const title = `Order ${$editor.entity.LookupCode} cancelled`;
                              $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
                              await $editor.refresh();
                              await $editor.tabs.sales_order_lines.activate();
                      }
  
                  }
                  else {
                      const dialogResult = await $shell.FootprintManager.opensales_order_cancellation_options_formDialog({
                          title: 'Select a reason code',
                          parentId: 45,
                          parentEntity: 'OperationType'
                      });
                      var userConfirmed = dialogResult.confirm;
                      var reasonCodeId = dialogResult.reasonCodeId;
  
                      if ($utils.isDefined(userConfirmed) && userConfirmed === false) {
  
                          return;
                      }
  
                      if (userConfirmed) {
  
                          const result = await $flows.SalesOrders.cancel_sales_order_shipment_and_order_lines_flow({
                              shipmentId: shipmentId,
                              reasonCodeId: reasonCodeId
                          });
                          const reason = result.reason;
  
                          if ($utils.isDefined(reason)) {
                              await $shell.FootprintManager.openErrorDialog('Order cannot be cancelled.', reason);
                              return;
                          }
                          else {
                              const title = `Order ${$editor.entity.LookupCode} cancelled`;
                              $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
                              await $editor.refresh();
                              await $editor.tabs.sales_order_lines.activate();
                          }
  
                      }
  
                  }
  
              } catch (error) {
                  const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                  const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                  const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
                  await $shell.FootprintManager.openErrorDialog('Cancel order error', 'An error occurred during the cancelling of the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
              }
          }
      }
  
  }
  else {
  
      throw new Error('Unable to determine the shipment for the selected order.')
  }
  }
  on_complete_clicked(event = null) {
    return this.on_complete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_complete_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  const result = await $flows.SalesOrders.is_sales_order_completable_flow({ orderId: $editor.entity.Id });
  const reason = result.reason;
  if ($utils.isDefined(reason)) {
      await $shell.FootprintManager.openErrorDialog('Order cannot be completed.', reason);
      return;
  } else {
      const confirm = await $shell.FootprintManager.openConfirmationDialog(`Complete order ${$editor.entity.LookupCode}?`, '', 'Complete order', 'Cancel');
      if (confirm) {
          try {
              const result = await $flows.SalesOrders.complete_sales_order_flow({ orderId: $editor.entity.Id });
              const reason = result.reason;
  
              if ($utils.isDefined(reason)) {
                  await $shell.FootprintManager.openErrorDialog('Order cannot be completed.', reason);
                  return;
              }
              else {
  
                  let title = `Order ${$editor.entity.LookupCode} completed`;
                  $shell.FootprintManager.openToaster(title,'',EToasterType.Success,{closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight});
                  await $editor.refresh();
                  await $editor.tabs.shipping_contents.activate();
              }
  
          } catch (error) {
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
              await $shell.FootprintManager.openErrorDialog('Order complete error', 'An error occurred during the completion of the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
          }
      }
  }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/12/2024
  
  // Set editor title
  $editor.title = `Outbound order ${$editor.entity.LookupCode}`;
  
  var shipTo = '';
  
  const orderAddress = (await $flows.Addresses.get_address_single_string_by_orderId({ orderId: $editor.inParams.orderId }));
  if ($utils.isDefined(orderAddress)) {
      shipTo = orderAddress.address;
  
  }
  // Only display ship from if it is not an auto generated account
  if ($utils.isDefined(shipTo)) {
      if (!shipTo.startsWith('ord-')) {
          $editor.fields.select_shipping_address_separator.hidden = true;
          $editor.fields.ship_to.hidden = false;
          $editor.fields.ship_to.control.text = shipTo;
          $editor.fields.ship_to_clear.hidden = false;
  
      } else {
          $editor.fields.select_shipping_address_separator.hidden = false;
          $editor.fields.ship_to.hidden = true;
          $editor.fields.ship_to.control.text = '';
          $editor.fields.ship_to_clear.hidden = true;
      }
  }
  else {
      $editor.fields.select_shipping_address_separator.hidden = false;
      $editor.fields.ship_to.hidden = true;
      $editor.fields.ship_to.control.text = '';
      $editor.fields.ship_to_clear.hidden = true;
  }
  
  // Apply appointment text logic
  const dockAppointments = (await $datasources.DockAppointments.ds_get_dock_appointment_by_orderId.get({
      orderId: $editor.inParams.orderId
  })).result;
  
  if ($utils.isDefined(dockAppointments)) {
      $editor.toolbar.appointment.control.label = (await $flows.DockAppointments.get_formatted_dock_appointment({
          dock_appointments: [{ id: dockAppointments[0]?.DockAppointmentId}],
      })).dock_appointments[0]?.formatted_value;
  
  } else {
      // Reset the appointment label back to original
      $editor.toolbar.appointment.control.styles.resetStyle();
      $editor.toolbar.appointment.control.label = 'Schedule appointment'
  }
  
  // Discussions feature
  let discussionCheck = (await $operations.Discussions.Enable_Discussions_Feature.isAuthorized())
  
  if (discussionCheck) {
      const discussions = (await $datasources.Discussions.ds_storage_discussions.getList({
          entity_name: 'Order',
          entity_id: $editor.inParams.orderId.toString()
      })).result;
  
      if ($utils.isDefined(discussions)) {
  
          let containsUnread = false;
          let containsDiscussion = false;
  
          for (let discussion of discussions) {
              let read_on = discussion.read_on
              let discussionData = discussion.discussion
  
              if (!$utils.isDefined(read_on) && discussion.id != '0') {
                  containsUnread = true;
              }
              if ($utils.isDefined(discussionData) && discussion.id != '0') {
                  containsDiscussion = true;
              }
          }
          if (containsDiscussion) {
              if (containsUnread) {
                  $editor.toolbar.discussions.control.icon = "icon-ic_fluent_chat_multiple_20_regular";
                  $editor.toolbar.discussions.control.styles.setDestructiveClass();
              }
              else {
                  $editor.toolbar.discussions.control.icon = "icon-ic_fluent_chat_20_regular";
                  $editor.toolbar.discussions.control.styles.setDestructiveClass();
              }
          }
          else {
  
              $editor.toolbar.discussions.control.icon =  "icon-ic_fluent_chat_20_regular";
             $editor.toolbar.discussions.control.styles.setCreationClass();
  
          }
      }
  }
  else {
      $editor.toolbar.discussions.control.readOnly = true;
  }
  
  
  // Fetch shipments
  const shipments = (await $datasources.SalesOrders.ds_get_shipments_by_orderId.get({ orderId: $editor.entity.Id })).result;
  
  //reprocess new orderlines feature
  const created_lines = (await $datasources.SalesOrders.ds_get_orderlines_by_orderId_linestatusids.get({orderId: $editor.inParams.orderId, order_status_ids: [2], line_status_ids: [1] })).totalCount
  if (created_lines>0 )
  {$editor.toolbar.process.control.label = 'Process new order lines'}
  
  
  
  if (shipments.length > 1) {
      // close
      await $shell.SalesOrders.openErrorDialog('Invalid order', 'This order has more than one shipment. This editor cannot display this kind of order. Editor will close');
      $editor.close();
      return;
  }
  
  else {
  
      $editor.fields.warehouse.control.readOnly = false;
      $editor.fields.warehouse.required = false;
  
      if (shipments.length === 1) {
          $editor.fields.container_identifier.control.readOnly = false;
          $editor.vars.shipmentId = shipments[0].ShipmentId;
          $editor.fields.warehouse.required = true;
      }
  
      const noWarehouse = $utils.isDefined($editor.fields.warehouse.control.value) === false;
  
      let stateId: number = 1;
      let has_manual: boolean = false;
      let stateName: string = $editor.entity.Status.Name;
  
      const orders = [{
          orderId: $editor.entity.Id,
          shipmentId: $editor.entity.ShipmentOrderLookups[0]?.ShipmentId
      }];
  
      const order_states = (await $flows.SalesOrders.get_sales_order_state({ orders: orders })).states;
  
      if (order_states.length > 0) {
          stateId = order_states[0].stateId;
          stateName = order_states[0].stateName;
          has_manual = order_states[0].has_manual;
      };
  
      $editor.vars.orderState = stateId;
      $editor.fields.order_state.control.text = stateName;
  
      // created status
      if ($editor.entity.OrderStatusId === 1) {
          $editor.toolbar.cancel.hidden = false;
          $editor.toolbar.on_delete.hidden = false;
          $editor.toolbar.on_delete.control.readOnly = false;
  
          // Reset process button in case the editor is refreshed back to a created status
          $editor.toolbar.process.hidden = false;
          $editor.toolbar.process.control.styles.resetStyle();
          $editor.toolbar.process.control.label = 'Process';
          $editor.toolbar.process.control.readOnly = false;
          $editor.toolbar.process.control.icon = "icon-ic_fluent_arrow_clockwise_dashes_20_regular";
  
          // disable process if no warehouse
          $editor.toolbar.process.control.readOnly = noWarehouse;
  
          $editor.toolbar.auto_load.hidden = true;
          $editor.toolbar.auto_pick.hidden = true;
          $editor.toolbar.complete.hidden = true;
          $editor.toolbar.revert.hidden = true;
  
          // disable owner project if order lines exist
          const hasOrderLines = $editor.entity.OrderLines.length > 0;
          $editor.fields.owner.control.readOnly = hasOrderLines;
          $editor.fields.project.control.readOnly = hasOrderLines;
  
          $editor.fields.lookupcode.control.readOnly = false;
          $editor.fields.order_class.control.readOnly = false;
          $editor.fields.vendor_reference.control.readOnly = false;
          $editor.fields.carrier.control.readOnly = false;
          $editor.fields.expected_date.control.readOnly = false;
  
          // Widgets
          $editor.widgets.order_total_picked_gross_widget.hidden = true;
          $editor.widgets.order_total_picked_units_widget.hidden = true;
  
          if ($editor.tabs.picking_tasks.active) {
              $editor.tabs.sales_order_lines.activate();
          }
  
          $editor.tabs.picking_tasks.hidden = true;
          $editor.tabs.manual_allocation_tasks.hidden = true;
          $editor.tabs.shipping_contents.hidden = true;
          $editor.tabs.tasks.hidden = true;
          $editor.tabs.billing.hidden = true;
          $editor.toolbar.options.control.buttons.temperature_readings.readOnly = true;
  
  
      } else if ($editor.entity.OrderStatusId === 2) {
          // processing status
  
          $editor.fields.lookupcode.control.readOnly = false;
          $editor.fields.order_class.control.readOnly = true;
          $editor.fields.owner.control.readOnly = true;
          $editor.fields.project.control.readOnly = true;
          $editor.fields.warehouse.control.readOnly = true;
          $editor.fields.vendor_reference.control.readOnly = false;
          $editor.fields.carrier.control.readOnly = false;
          $editor.fields.expected_date.control.readOnly = false;
  
          $editor.tabs.tasks.hidden = false;
          $editor.tabs.billing.hidden = false;
          $editor.toolbar.options.control.buttons.temperature_readings.readOnly = false;
  
          const shipmentContents = (await $datasources.SalesOrders.ds_get_shipmentscontents_by_orderId_shipmentId_top1.get({
              orderId: $editor.inParams.orderId,
              shipmentId: $editor.vars.shipmentId
          })).result;
  
          // Revert button and Shipping Contents 'Picked' tab
          if ($utils.isDefined(shipmentContents)) {
              $editor.toolbar.revert.hidden = false;
              $editor.toolbar.revert.control.readOnly = true;
  
              $editor.tabs.shipping_contents.hidden = false;
              //  $editor.tabs.reports.tabs.bol_report.hidden = false;
          } else {
              $editor.toolbar.revert.hidden = false;
              $editor.toolbar.revert.control.readOnly = false;
  
              $editor.tabs.shipping_contents.hidden = true;
              //  $editor.tabs.reports.tabs.bol_report.hidden = true;
          }
  
          // Set manual allocations
          var manualAllocations;
          if ($utils.isDefined(has_manual)) {
  
              if (has_manual) {
                  $editor.tabs.manual_allocation_tasks.hidden = false;
                  manualAllocations = true;
              } else {
                  manualAllocations = false;
                  $editor.tabs.manual_allocation_tasks.hidden = true;
              }
          } else {
              manualAllocations = false;
              $editor.tabs.manual_allocation_tasks.hidden = true;
          }
  
          if ($utils.isDefined(stateId)) {
              switch (stateId) {
  
                  case 2: {
                      $editor.toolbar.cancel.hidden = false;
                      $editor.toolbar.cancel.control.readOnly = false;
  
                      $editor.toolbar.process.hidden = false;
                      $editor.toolbar.process.control.readOnly = false;
  
                      $editor.toolbar.on_delete.hidden = true;
                      $editor.toolbar.auto_load.hidden = true;
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.complete.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = true;
  
                      break;
                  }
                  case 3: {
                      $editor.toolbar.cancel.hidden = false;
                      $editor.toolbar.cancel.control.readOnly = false;
  
                      $editor.toolbar.process.hidden = false;
                      $editor.toolbar.process.control.readOnly = false;
  
                      $editor.toolbar.on_delete.hidden = true;
                      $editor.toolbar.auto_load.hidden = true;
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.complete.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = true;
  
                      break;
                  }
                  case 4: {
                      $editor.toolbar.cancel.hidden = false;
                      $editor.toolbar.cancel.control.readOnly = false;
  
                      $editor.toolbar.process.hidden = false;
                      $editor.toolbar.process.control.readOnly = false;
  
                      $editor.toolbar.on_delete.control.readOnly = true;
                      $editor.toolbar.auto_load.hidden = true;
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.complete.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = true;
  
                      // $editor.tabs.reports.tabs.pick_slip_report.hidden = false;
  
                      break;
                  }
                  // All pick tasks in a released status
                  case 5: {
                      $editor.toolbar.cancel.hidden = false;
                      $editor.toolbar.cancel.control.readOnly = false;
                      $editor.toolbar.auto_pick.hidden = false;
  
                      $editor.toolbar.on_delete.control.readOnly = true;
  
                      if (created_lines>0)
                      {$editor.toolbar.process.hidden = false;}
                      else
                      {$editor.toolbar.process.hidden = true;}
                      
                      $editor.toolbar.auto_load.hidden = true;
                      $editor.toolbar.complete.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = false;
  
                      //  $editor.tabs.reports.tabs.pick_slip_report.hidden = false;
  
                      break;
                  } // One or more pick tasks completed and one or more pick tasks released
                  case 6: {
                      $editor.toolbar.auto_pick.hidden = false;
                      $editor.toolbar.auto_load.hidden = false;
                      $editor.toolbar.cancel.control.readOnly = true;
                      $editor.toolbar.on_delete.control.readOnly = true;
  
                      if (created_lines>0)
                      {$editor.toolbar.process.hidden = false;}
                      else
                      {$editor.toolbar.process.hidden = true;}
  
                      $editor.toolbar.complete.hidden = true;
                      $editor.tabs.picking_tasks.hidden = false;
  
  
                      break;
                  } // No released pick tasks exist and one or more shipping licenseplates require a loading task
                  case 7: {
                      $editor.toolbar.auto_load.hidden = false;
  
                      $editor.toolbar.cancel.control.readOnly = true;
                      $editor.toolbar.on_delete.control.readOnly = true;
                      if (created_lines>0)
  
                      {$editor.toolbar.process.hidden = false;}
                      else
                      {$editor.toolbar.process.hidden = true;}
  
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.complete.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = true;
  
                      //   $editor.tabs.reports.tabs.pick_slip_report.hidden = true;
  
                      break;
                  } // No released pick tasks or manual allocations exist and all shipping licenseplates loaded
                  case 8: {
                      if (manualAllocations) {
                          $editor.toolbar.complete.hidden = false;
                          $editor.toolbar.complete.control.readOnly = true;
                      } else {
                          $editor.toolbar.complete.hidden = false;
                          $editor.toolbar.complete.control.readOnly = false;
  
                          //  $editor.tabs.reports.tabs.pick_slip_report.hidden = true;
                      }
  
                      $editor.toolbar.cancel.control.readOnly = true;
                      $editor.toolbar.on_delete.control.readOnly = true;
  
                      if (created_lines>0)
                      {$editor.toolbar.process.hidden = false;}
                      else
                      {$editor.toolbar.process.hidden = true;}
  
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.auto_load.hidden = true;
  
                      $editor.tabs.picking_tasks.hidden = true;
  
                      break;
                  }
                  // No released pick tasks or manual allocations exist and all shipping contents unpicked
                  case 9: {
                      if (manualAllocations) {
                          $editor.toolbar.complete.hidden = false;
                          $editor.toolbar.complete.control.readOnly = true;
                          $editor.toolbar.cancel.hidden = false;
                          $editor.toolbar.cancel.control.readOnly = true;
                      } else {
                          $editor.toolbar.complete.hidden = false;
                          $editor.toolbar.complete.control.readOnly = true;
                          $editor.toolbar.cancel.hidden = false;
                          $editor.toolbar.cancel.control.readOnly = false;
                      }
  
  
                      $editor.toolbar.on_delete.control.readOnly = true;
  
                      if (created_lines>0)
                      {$editor.toolbar.process.hidden = false;}
                      else
                      {$editor.toolbar.process.hidden = true;}
  
                      $editor.toolbar.auto_pick.hidden = true;
                      $editor.toolbar.auto_load.hidden = true;
                      $editor.tabs.picking_tasks.hidden = true;
  
                      break;
                  }
              }
          } else {
              if (manualAllocations) {
                  $editor.fields.order_status.control.text = 'Manual Allocations'
                  $editor.toolbar.complete.hidden = false;
                  $editor.toolbar.complete.control.readOnly = true;
              }
  
              if (created_lines>0)
              {$editor.toolbar.process.hidden = false;}
              else
              {$editor.toolbar.process.hidden = true;}
              
              //$editor.toolbar.process.hidden = true;        
              $editor.toolbar.auto_load.hidden = true;
              $editor.toolbar.auto_pick.hidden = true;
  
              $editor.tabs.reports.tabs.pick_slip_report.hidden = true;
  
          }
          // Widgets
          $editor.widgets.order_total_picked_gross_widget.hidden = false;
          $editor.widgets.order_total_picked_units_widget.hidden = false;
  
  
      } else {
  
          if (created_lines>0)
          {$editor.toolbar.process.hidden = false;}
          else
          {$editor.toolbar.process.hidden = true;}
  
          //$editor.toolbar.process.hidden = true;            
          $editor.toolbar.cancel.hidden = true;
          $editor.toolbar.complete.hidden = true;
          $editor.toolbar.on_delete.hidden = true;
          $editor.toolbar.auto_load.hidden = true;
          $editor.toolbar.auto_pick.hidden = true;
          $editor.toolbar.revert.hidden = true;
  
          $editor.fields.lookupcode.control.readOnly = true;
          $editor.fields.order_class.control.readOnly = true;
          $editor.fields.owner.control.readOnly = true;
          $editor.fields.project.control.readOnly = true;
          $editor.fields.vendor_reference.control.readOnly = true;
          $editor.fields.carrier.control.readOnly = true;
          $editor.fields.warehouse.control.readOnly = true;
          $editor.fields.expected_date.control.readOnly = true;
  
          // Widgets
          $editor.widgets.order_total_picked_gross_widget.hidden = false;
          $editor.widgets.order_total_picked_units_widget.hidden = false;
  
          $editor.tabs.picking_tasks.hidden = true;
  
          $editor.tabs.shipping_contents.hidden = false;
          // $editor.tabs.reports.tabs.bol_report.hidden = false;
          //  $editor.tabs.reports.tabs.pick_slip_report.hidden = true;
  
          $editor.tabs.tasks.hidden = false;
          $editor.tabs.billing.hidden = false;
          $editor.toolbar.options.control.buttons.temperature_readings.readOnly = false;
  
      }
  }
  
  
  //Integration information
  
  let integration_info = (await $flows.FootprintManager.get_integration_info_by_order_id({ order_id: $editor.inParams.orderId }));
  
  if ($utils.isDefined(integration_info?.Source)) {
      $editor.fields.integration_information.hidden = false;
      $editor.fields.integration_information.control.label = integration_info.Source;
  }
  $editor.fields.pickup_date.control.readOnly = false;
  $editor.fields.pickup_date.control.format =
      `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`
  
   
  
  if ($editor.entity.Notes?.length > 0) { 
  
      $editor.fieldsets.notes.expanded = true; 
  
  } 
  // Apply operations should always be the final step
  $editor.apply_operations();
  
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $editor.tabs.picking_tasks.hidden = true;
  $editor.tabs.manual_allocation_tasks.hidden = true;
  $editor.tabs.shipping_contents.hidden = true;
  $editor.fields.integration_information.hidden = true;
  
  if (await $operations.FootprintManager.Disable_SalesOrders_AutoPicking.isAuthorized()) {
      $editor.toolbar.auto_pick.hidden = true;
  }
  
  // Call common flow to apply the role based permissions
  await $editor.apply_operations();
  
  // Set Date/Time Formats
  $editor.fields.expected_date.control.format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  // Create shipment if none found
  const shipments = (await $datasources.SalesOrders.ds_get_shipments_by_orderId.get({ orderId: $editor.inParams.orderId })).result;
  if (!$utils.isDefined(shipments)) {
  
      const nextShipmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: 'Shipment' })).nextId;
  
      const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $editor.inParams.orderId })).result;
  
      if ($utils.isAllDefined(order, order.PreferredWarehouseId)) {
  
          // create shipment order lookup
          const payload = {
              "OrderId": $editor.inParams.orderId,
              "Shipment": {
                  "Id": nextShipmentId,
                  "LookupCode": order.LookupCode,
                  "CarrierId": order.PreferredCarrierId,
                  "CarrierServiceTypeId": order.PreferredCarrierServiceTypeId,
                  "ExpectedWarehouseId": order.PreferredWarehouseId,
                  "ExpectedDate": order.RequestedDeliveryDate,
                  "Cartonized": false,
                  "ConfirmSeal": false,
                  "StatusId": 1,
                  "Transhipment": false,
                  "TypeId": 2
              }
          }
          await $flows.Utilities.crud_create_flow({ entitySet: 'ShipmentOrderLookup', entity: payload });
          $editor.vars.shipmentId = nextShipmentId;
      }
  }
  
  // Set warehouse on order if blank and shipment contains expected warehouse
  const orders = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $editor.inParams.orderId })).result;
  if (!$utils.isDefined(orders.PreferredWarehouseId) && $utils.isDefined(shipments[0]?.Shipment?.ExpectedWarehouseId)) {
  
      let payload: any = {};
  
      payload.PreferredWarehouseId = shipments[0]?.Shipment?.ExpectedWarehouseId;
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: $editor.inParams.orderId, entity: payload });
  }
  
  //reprocess new orderlines feature
  var reprocess: boolean = false
  const created_lines = (await $datasources.SalesOrders.ds_get_orderlines_by_orderId_linestatusids.get({ orderId: $editor.inParams.orderId, order_status_ids: [2], line_status_ids: [1] })).totalCount
  //if (created_lines>0 && $utils.isDefined(shipment_info.WaveId))
  if (created_lines > 0) { $editor.toolbar.process.control.label = 'Process new order lines' }
  
  
  $editor.vars.is_edi = (await $flows.FootprintManager.is_edi_order_flow({ order_id: $editor.inParams.orderId }))?.result ?? false;
  
  if (!$editor.vars.is_edi) {
      $editor.fieldsets.additional_details.hidden = true;
  } else {
      $editor.fieldsets.additional_details.hidden = false;
      $editor.toolbar.options.control.buttons.convert_edi.readOnly = true;
  }
  
  $editor.toolbar.cancel.hidden = (await $operations.FootprintManager.Disable_SalesOrders_Cancellation.isAuthorized());
  $editor.toolbar.on_delete.hidden = (await $operations.FootprintManager.Disable_SalesOrders_Deletion.isAuthorized());
  }
  on_owner_changed(event = null) {
    return this.on_owner_changedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $editor.fields.project.control.value = null;
  }
  on_process_clicked(event = null) {
    return this.on_process_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_process_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var section = 'order processing';
  
  try {
      const orderlines = (await $datasources.SalesOrders.ds_get_orderlines_by_orderId_without_children.get({ orderId: $editor.entity.Id })).result;
      if (!$utils.isDefined(orderlines)) {
          throw new Error('Order must have at least one order line to process.')
      }
  
      // Order Substitution Flow Execution
      section = 'order substitution';
      const sub = await $flows.SalesOrders.substitution_sales_order_flow({ orderId: $editor.entity.Id });
      if ($utils.isDefined(sub.reason)) {
          throw new Error(sub.reason);
      }
  
      section = 'order processing';
      const isProcessable = await $flows.SalesOrders.is_sales_order_processable_flow({ orderId: $editor.entity.Id });
  
      if ($utils.isDefined(isProcessable.reason)) {
          throw new Error(isProcessable.reason);
      }
  
      // Check if the order contains at least one order line that can be expanded into children kit components
      let expand_kits = false;
      const kits = (await $datasources.SalesOrders.ds_get_material_kit_order_line_by_order_id_top1.get({ order_ids: [$editor.entity.Id] })).result;
      if ($utils.isDefined(kits)) {
          expand_kits = true;
      }
  
      //reprocess new orderlines feature
      var reprocess: boolean = false
      var is_wave_created: boolean = false
      const shipment_info = (await $datasources.SalesOrders.ds_get_shipments_by_shipmentId.get({ shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId })).result;
      const created_lines = (await $datasources.SalesOrders.ds_get_orderlines_by_orderId_linestatusids.get({ orderId: $editor.inParams.orderId, order_status_ids: [2], line_status_ids: [1] })).totalCount
      //if (created_lines>0 && $utils.isDefined(shipment_info.WaveId))
      if (created_lines > 0) { reprocess = true }
      if ($utils.isDefined(shipment_info.WaveId)) { is_wave_created = true }
  
  
  
      /*** Prompt for processing sales order options ***/
      const dialogResult = await $shell.FootprintManager.opensales_orders_processing_options_formDialog({
          order_ids: [$editor.entity.Id],
          default_waving: true,
          expand_order_line_kits: expand_kits,
          is_wave_created: is_wave_created
      }, 'modal');
  
      if (!dialogResult.confirm) { return; }
  
      dialogResult.waveOptions.priority = $utils.isDefined(dialogResult.waveOptions?.priority) ? dialogResult.waveOptions.priority : 1;
      dialogResult.waveOptions.description = $utils.isDefined(dialogResult.waveOptions?.description) ? dialogResult.waveOptions.description : `Created via processing flow`
      dialogResult.waveOptions.isCreateManualAllocationTasks = dialogResult.waveOptions.isCreateManualAllocationTasks ?? false;
  
  
  
      let targetState = 2 // process order
      if (dialogResult.waveOptions.isCreateWave) { targetState = 3; }
      if (dialogResult.waveOptions.isProcessWave) { targetState = 4; }
      if (dialogResult.waveOptions.isReleaseWave) { targetState = 5; }
  
      let processingStrategyWorkflowCode = dialogResult.processingStrategyWorkflowId;
      let expand_kits_request = dialogResult.expand_order_line_kits_request;
  
  
  
      // Begin processing
      $editor.toolbar.process.control.readOnly = true;
      $editor.toolbar.process.control.icon = "icon datex-default-spinner";
  
      $editor.toolbar.cancel.control.readOnly = true;
      $editor.toolbar.on_delete.control.readOnly = true;
  
      // Create children kit order lines if required
      if ($utils.isDefined(expand_kits_request) && expand_kits_request === true) {
  
          $editor.toolbar.process.control.label = 'Expanding kits';
          const component_lines = (await $datasources.SalesOrders.ds_get_material_kit_order_lines_by_order_id.get({
              order_id: $editor.inParams.orderId
          })).result;
          if ($utils.isDefined(component_lines)) {
  
              for (let component_line of component_lines) {
  
                  const order_line_packaging_id = component_line.PackagedId;
                  const kits = component_line.Material?.Kits
                  if ($utils.isDefined(kits)) {
                      for (let kit of kits) {
  
                          const kit_packaging = kit.PackagingId
                          //Only create kit components where the packaging on the order line matches the packaging on the configured parent kit material
                          if (kit_packaging == order_line_packaging_id) {
  
                              const orderLine = (await $flows.SalesOrders.create_sales_order_line_flow({
                                  orderId: $editor.inParams.orderId,
                                  packagedAmount: component_line.PackagedAmount * kit.ComponentPackagedAmount,
                                  materialId: kit.ComponentMaterialId,
                                  packagingId: kit.ComponentPackagedId,
                                  shipmentId: $editor.entity.ShipmentOrderLookups[0]?.ShipmentId
                              }));
                              if ($utils.isDefined(orderLine)) {
  
                                  if (!$utils.isDefined(orderLine.linenumber)) {
  
                                      throw new Error('Unable to create order line.')
                                  }
                                  else {
  
                                      let payload: any = {};
  
                                      if ($utils.isDefined(component_line.LineNumber)) {
                                          payload.ParentLineNumber = component_line.LineNumber;
                                      }
  
                                      if (Object.keys(payload).length > 0) {
                                          await $flows.Utilities.crud_update_dual_pk_flow({
                                              entitySet: 'OrderLines',
                                              pk1String: 'OrderId',
                                              pk1: $editor.inParams.orderId,
                                              pk2String: 'LineNumber',
                                              pk2: orderLine.linenumber,
                                              entity: payload
                                          });
                                      }
                                  }
                              }
                              else {
                                  throw new Error('Unable to create order line.')
                              }
  
                          }
                      }
                  }
  
  
              }
  
  
          }
  
  
      }
  
      // Set custom status
      let stateId: number = 1;
  
      const orders = [{
          orderId: $editor.entity.Id,
          shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId
      }];
  
      const order_states = (await $flows.SalesOrders.get_sales_order_state({ orders: orders })).states;
  
      if (order_states.length > 0) {
          stateId = order_states[0].stateId;
      };
  
      if (stateId < targetState) {
  
          if (reprocess) {
              section = 'Reprocess new sales order lines';
              $editor.toolbar.process.control.label = 'Processing'
              let result = await $flows.SalesOrders.reprocess_new_sales_order_lines_by_shipment({
                  order_id: $editor.entity.Id,
                  shipment_id: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
                  processing_strategy_workflow_code: processingStrategyWorkflowCode
              });
  
              if ($utils.isDefined(result.reason)) {
                  throw new Error(result.reason);
              }
          }
  
          for (let i = stateId; i < targetState; i++) {
              switch (i) {
                  case 1: {
                      section = 'order processing';
                      let soft = await $flows.SalesOrders.is_sales_order_soft_allocatable_flow({
                          orderId: $editor.entity.Id
                      });
  
                      $editor.toolbar.process.control.label = 'Processing'
  
                      let result = await $flows.SalesOrders.process_sales_order_flow({
                          order_id: $editor.entity.Id,
                          shipment_id: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
                          processing_strategy_workflow_code: processingStrategyWorkflowCode
                      });
  
                      if ($utils.isDefined(result.reason)) {
                          throw new Error(result.reason);
                      }
  
  
  
                      break;
                  }
                  case 2: {
                      section = 'wave creation';
                      $editor.toolbar.process.control.label = 'Creating Wave'
                      let result = await $flows.SalesOrders.create_wave_sales_order_flow({
                          orderId: $editor.entity.Id,
                          shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId
                      });
  
                      if ($utils.isDefined(result.reason)) {
                          throw new Error(result.reason);
                      }
  
                      break;
                  }
                  case 3: {
                      section = 'wave processing';
                      $editor.toolbar.process.control.label = 'Processing Wave'
                      let result = await $flows.SalesOrders.process_wave_sales_order_flow({
                          orderId: $editor.entity.Id,
                          shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
                          is_create_manual_allocation_tasks: dialogResult.waveOptions.isCreateManualAllocationTasks
  
                      });
  
                      if ($utils.isDefined(result.reason)) {
                          throw new Error(result.reason);
                      }
  
                      break;
                  }
                  case 4: {
                      section = 'wave release';
                      $editor.toolbar.process.control.label = 'Releasing Wave'
                      let result = await $flows.SalesOrders.release_wave_sales_order_flow({
                          orderId: $editor.entity.Id,
                          shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId
                      });
  
                      if ($utils.isDefined(result.reason)) {
                          throw new Error(result.reason);
                      }
  
                      break;
                  }
              }
          }
      }
      else {
          if (reprocess) {
              section = 'Reprocess new sales order lines';
              $editor.toolbar.process.control.label = 'Processing'
              let result = await $flows.SalesOrders.reprocess_new_sales_order_lines_by_shipment({
                  order_id: $editor.entity.Id,
                  shipment_id: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
                  processing_strategy_workflow_code: processingStrategyWorkflowCode
              });
  
              if ($utils.isDefined(result.reason)) {
                  throw new Error(result.reason);
              }
          }
      }
  
      section = 'order processing';
      const title = `Order ${$editor.entity.LookupCode} processed`
      $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
  
      await $editor.tabs.picking_tasks.activate();
  
  
  } catch (error) {
      while ($utils.isDefined(error.error)) {
          error = error.error;
      }
  
      await $shell.FootprintManager.openErrorDialog(`Error during ${section}`, error.message);
  }
  
  
  $editor.toolbar.process.control.styles.resetStyle();
  $editor.toolbar.process.control.icon = "icon-ic_fluent_arrow_clockwise_dashes_20_regular";
  $editor.toolbar.process.control.label = 'Process';
  
  $editor.toolbar.process.control.readOnly = false;
  $editor.toolbar.cancel.control.readOnly = false;
  $editor.toolbar.on_delete.control.readOnly = false;
  
  $editor.refresh();
  }
  on_save(event = null) {
    return this.on_saveInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_saveInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const allRequiredFieldHaveValues = $utils.isAllDefined(
      $editor.fields.lookupcode.control.value,
      $editor.fields.order_class.control.value,
      $editor.fields.project.control.value
  );
  
  if (allRequiredFieldHaveValues === false) {
      return;
  }
  
  var shipmentId = $editor.vars.shipmentId;
  
  
  let payload: any = {};
  if ($editor.fields.project.control.isChanged) {
      payload.ProjectId = $editor.fields.project.control.value;
  }
  if ($editor.fields.lookupcode.control.isChanged) {
      payload.LookupCode = $editor.fields.lookupcode.control.value;
  }
  if ($editor.fields.order_class.control.isChanged) {
      payload.OrderClassId = $editor.fields.order_class.control.value;
  }
  if ($editor.fields.reference.control.isChanged) {
      payload.OwnerReference = $editor.fields.reference.control.value;
  }
  if ($editor.fields.vendor_reference.control.isChanged) {
      payload.VendorReference = $editor.fields.vendor_reference.control.value;
  }
  if ($editor.fields.carrier.control.isChanged) {
      payload.PreferredCarrierId = $editor.fields.carrier.control.value;
      // Clear the carrier service type as it could conflict with the newly selected carrier
      payload.PreferredCarrierServiceTypeId = null;
      $editor.fields.carrier_service.control.value = null;
      $editor.fields.carrier_service.control.displayText = null;
  }
  if ($editor.fields.carrier_service.control.isChanged) {
      payload.PreferredCarrierServiceTypeId = $editor.fields.carrier_service.control.value;
  }
  if ($editor.fields.warehouse.control.isChanged) {
      if (!$utils.isDefined($editor.fields.warehouse.control.value)) {
          throw new Error('Please select a warehouse.')
      }
      else {
          payload.PreferredWarehouseId = $editor.fields.warehouse.control.value;
      }
  }
  if ($editor.fields.requested_date.control.isChanged) {
      payload.RequestedDeliveryDate = $editor.fields.requested_date.control.value;
  }
  if ($editor.fields.notes.control.isChanged) {
      payload.Notes = $editor.fields.notes.control.value;
  }
  
  
  
  await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: $editor.entity.Id, entity: payload });
  
  
  // Create the shipment if it does not exist only if the order has a preferred warehouse of if the preferred warehouse is selected in the editor
  if (!$utils.isDefined(shipmentId)) {
  
      const nextShipmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: 'Shipment' })).nextId;
  
      const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $editor.inParams.orderId })).result;
  
  
  
      if ($utils.isAllDefined(order, order.PreferredWarehouseId) || $utils.isAllDefined(order, $editor.fields.warehouse.control.value)) {
  
          // create shipment order lookup
          const payload = {
              "OrderId": $editor.inParams.orderId,
              "Shipment": {
                  "Id": nextShipmentId,
                  "LookupCode": order.LookupCode,
                  "CarrierId": order.PreferredCarrierId,
                  "CarrierServiceTypeId": order.PreferredCarrierServiceTypeId,
                  "ExpectedWarehouseId": $utils.isDefined($editor.fields.warehouse.control.value) ? $editor.fields.warehouse.control.value : order.PreferredWarehouseId,
                  "ExpectedDate": order.RequestedDeliveryDate,
                  "Cartonized": false,
                  "ConfirmSeal": false,
                  "StatusId": 1,
                  "Transhipment": false,
                  "TypeId": 2,
                  "PickUpDate": $editor.fields.pickup_date.control.value,
                  "PaymentTermId": $editor.fields.payment_term.control.value,
                  "Notes": $editor.fields.notes.control.value
              }
          }
          await $flows.Utilities.crud_create_flow({ entitySet: 'ShipmentOrderLookup', entity: payload });
  
          shipmentId = nextShipmentId;
          $editor.vars.shipmentId = nextShipmentId;
  
      }
  
  }
  
  if ($utils.isDefined(shipmentId)) {
  
      payload = {};
  
      if ($editor.fields.lookupcode.control.isChanged) {
          payload.LookupCode = $editor.fields.lookupcode.control.value;
      }
  
      if ($editor.fields.shipment_carrier.control.isChanged) {
          payload.CarrierId = $editor.fields.shipment_carrier.control.value;
          // Clear the carrier service type as it could conflict with the newly selected carrier
          payload.CarrierServiceTypeId = null;
          $editor.fields.shipment_carrier_service.control.value = null;
          $editor.fields.shipment_carrier_service.control.displayText = null;
      }
      if ($editor.fields.carrier.control.isChanged && !$utils.isDefined($editor.fields.shipment_carrier.control.value)) {
          payload.CarrierId = $editor.fields.carrier.control.value;
          // Clear the carrier service type as it could conflict with the newly selected carrier
          payload.CarrierServiceTypeId = null;
          $editor.fields.shipment_carrier_service.control.value = null;
          $editor.fields.shipment_carrier_service.control.displayText = null;
      }
  
      if ($editor.fields.shipment_carrier_service.control.isChanged) {
          payload.CarrierServiceTypeId = $editor.fields.shipment_carrier_service.control.value;
      }
      if ($editor.fields.carrier_service.control.isChanged && !$utils.isDefined($editor.fields.shipment_carrier_service.control.value)) {
          payload.CarrierServiceTypeId = $editor.fields.carrier_service.control.value;
      }
  
      if ($editor.fields.warehouse.control.isChanged) {
          if (!$utils.isDefined($editor.fields.warehouse.control.value)) {
              throw new Error('Please select a warehouse.')
          }
          else {
              payload.ExpectedWarehouseId = $editor.fields.warehouse.control.value;
          }
      }
      if ($editor.fields.expected_date.control.isChanged) {
          payload.ExpectedDate = $editor.fields.expected_date.control.value;
      }
      if ($editor.fields.container_identifier.control.isChanged) {
          payload.ContainerIdentifier = $editor.fields.container_identifier.control.value;
      }
      
      if ($editor.fields.notes.control.isChanged && !$utils.isDefined($editor.fields.shipment_notes.control.value)) {
          payload.Notes = $editor.fields.notes.control.value;
      }
      if ($editor.fields.shipment_notes.control.isChanged) {
          payload.Notes = $utils.isDefined($editor.fields.shipment_notes.control.value) ? $editor.fields.shipment_notes.control.value : $editor.fields.notes.control.value;
      }
  
      if ($editor.fields.bill_of_lading.control.isChanged) {
          payload.BillOfLading = $editor.fields.bill_of_lading.control.value;
      }
      if ($editor.fields.seal.control.isChanged) {
          payload.SealId = $editor.fields.seal.control.value;
      }
      if ($editor.fields.trailer.control.isChanged) {
          payload.TrailerId = $editor.fields.trailer.control.value;
      }
      if ($editor.fields.reference.control.isChanged) {
          payload.ReferenceNumber = $editor.fields.reference.control.value;
      }
      if ($editor.fields.tracking.control.isChanged) {
          payload.TrackingIdentifier = $editor.fields.tracking.control.value;
      }
  
      if ($editor.fields.pickup_date.control.isChanged) {
          payload.PickupDate = $editor.fields.pickup_date.control.value;
      }
      if ($editor.fields.payment_term.control.isChanged) {
          payload.PaymentTermId = $editor.fields.payment_term.control.value;
      }
  
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Shipments', id: $editor.vars.shipmentId, entity: payload });
  
  }
  
  await $editor.refresh();
  }
  on_ship_to_clicked(event = null) {
    return this.on_ship_to_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_ship_to_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 03/29/2024
  
  const dialogResult = await $shell.FootprintManager.openaccounts_gridDialog({
      ownerId: $editor.entity.Project.OwnerId,
      typeIds: [2, 4, 5], // Shipping, Residential, Commerical
      accountTypeId: 2, // Customer
      allowSelection: true
  });
  
  const userConfirmed = dialogResult.confirm;
  const accountId = dialogResult.accountId;
  const addressId = dialogResult.addressId;
  const contactId = dialogResult.contactId;
  const ownerId = dialogResult.ownerId;
  
  if (userConfirmed && $utils.isAllDefined(accountId, addressId)) {
      let payload: any = {};
  
      payload.AccountId = accountId;
      payload.BillingAddresId = addressId;
      await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: $editor.entity.Id, entity: payload });
  
      if (ownerId === 0) {
  
          const owner_account = (await $datasources.Addresses.ds_find_owner_account_lookup.get({ ownerId: $editor.entity.Project.OwnerId, accountId: accountId })).result;
  
          if (!$utils.isDefined(owner_account)) {
              // OwnersAccounts
              const payload = {
                  "OwnerId": $editor.entity.Project.OwnerId,
                  "AccountId": accountId,
                  "IsDefaultAccount": false
              }
              await $flows.Utilities.crud_create_flow({ entitySet: 'OwnersAccountsLookup', entity: payload });
          }
      }
  
      if ($utils.isDefined($editor.entity.ShipmentOrderLookups)) {
          const shipmentId = $editor.entity.ShipmentOrderLookups[0].ShipmentId;
          let shipment_payload: any = {};
  
          shipment_payload.AccountId = accountId;
          shipment_payload.ContactId = contactId;
  
          await $flows.Utilities.crud_update_flow({ entitySet: 'Shipments', id: shipmentId, entity: shipment_payload });
      }
  }
  // Always refresh as the user might have made some changes to an existing address
  await $editor.refresh();
  }
  on_auto_pick_clicked(event = null) {
    return this.on_auto_pick_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_auto_pick_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Check if order is pickable
  const result = await $flows.SalesOrders.is_sales_order_pickable_flow({
      orderId: $editor.entity.Id,
      shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId
  });
  
  const reason = result.reason;
  if ($utils.isDefined(reason)) {
      $shell.FootprintManager.openToaster('Order cannot be picked.', reason, EToasterType.Error, { closeButton: true, timeOut: 7000, positionClass: EToasterPosition.bottomRight });
      return;
  }
  
  // Get warehouseId
  var warehouseId = $editor.entity.PreferredWarehouseId
  if (!$utils.isDefined(warehouseId)) {
  
      openErrorToaster('Order Auto Pick Error', 'Unable to determine preferred warehouse from first order selected');
      return;
  }
  
  
  // Get assigned or scheduled dock door from dock appointment if it exists
  const dockappointment = (await $datasources.DockAppointments.ds_get_dock_appointment_by_orderId.get({ orderId: $editor.entity.Id })).result;
  if ($utils.isDefined(dockappointment)) {
  
      const doorId = dockappointment[0]?.DockAppointment?.AssignedLocation?.Id ?? dockappointment[0]?.DockAppointment?.ScheduledLocation?.Id;
  
      if ($utils.isDefined(doorId)) {
          const dockDoor = (await $datasources.DockAppointments.ds_get_dock_door_by_locationId.get({ locationId: doorId })).result;
          if ($utils.isDefined(dockDoor)) {
              // Get child location of type inventory
              var locationId = dockDoor.ChildLocationContainers[0]?.Id
          }
  
      }
  }
  
  // Get user input for auto-picking
  const dialogResult = await $shell.FootprintManager.openauto_pick_options_formDialog({
      warehouse_id: warehouseId,
      load_location_id: locationId
  });
  
  var userConfirmed = dialogResult.confirm;
  var autoLoadConfirmed = dialogResult.auto_load;
  var loadLocation = dialogResult.load_location;
  let license_plate_lookup = dialogResult.license_plate_lookup;
  
  if (!userConfirmed) { return; }
  
  try {
      const result = await $flows.SalesOrders.auto_pick_sales_order_flow({
          orderId: $editor.entity.Id,
          shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
          license_plate_lookup: license_plate_lookup
      });
      const reason = result.reason;
  
      if ($utils.isAllDefined(userConfirmed, autoLoadConfirmed) && autoLoadConfirmed === true) {
  
          const flowLoadParams = {
              orderId: $editor.entity.Id,
              shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
              loadLocation: $utils.isDefined(loadLocation) ? loadLocation : null
          }
          const resultLoad = await $flows.SalesOrders.auto_load_sales_order_flow(flowLoadParams);
          var reasonLoad = resultLoad.reason;
      }
  
      if ($utils.isDefined(reason)) {
          openErrorToaster('Order cannot be fully auto picked.', reason);
          await $editor.refresh();
          await $editor.tabs.picking_tasks.activate();
          return;
      }
      else if ($utils.isDefined(reasonLoad)) {
          openErrorToaster('Order cannot be fully auto loaded.', reasonLoad);
          await $editor.refresh();
          await $editor.tabs.shipping_contents.activate();
          return;
      }
      else {
  
          const loadmessage = (autoLoadConfirmed === true) ? ' and loaded' : ''
          const title = `Order ${$editor.entity.LookupCode} picked${loadmessage}`;
          $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
          await $editor.refresh();
          await $editor.tabs.shipping_contents.activate();
      }
  
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
      const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
      await $shell.FootprintManager.openErrorDialog('Auto pick order error', 'An error occurred during the auto picking of the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
      await $editor.refresh();
      await $editor.tabs.picking_tasks.activate();
  }
  
  
  
  
  /************************************
   * FUNCTIONS
  *************************************/
  function openErrorToaster(title: string, message?: string) {
      $shell.FootprintManager.openToaster(title, message, EToasterType.Error, { closeButton: true, timeOut: 7000, positionClass: EToasterPosition.bottomRight });
  }
  }
  on_auto_load_clicked(event = null) {
    return this.on_auto_load_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_auto_load_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const result = await $flows.SalesOrders.is_sales_order_loadable_flow({
      orderId: $editor.entity.Id,
      shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId
  });
  
  const reason = result.reason;
  if ($utils.isDefined(reason)) {
      await $shell.FootprintManager.openErrorDialog('Order cannot be loaded.', reason);
      return;
  } else {
  
      var warehouseId = $editor.entity.PreferredWarehouseId
      if (!$utils.isDefined(warehouseId)) {
  
          $shell.FootprintManager.openErrorDialog('Order Auto Load Error', 'Unable to determine preferred warehouse from first order selected');
          return;
      }
      // Get assigned or scheduled dock door from dock appointment if it exists
      const dockappointment = (await $datasources.DockAppointments.ds_get_dock_appointment_by_orderId.get({ orderId: $editor.entity.Id })).result;
  
      if ($utils.isDefined(dockappointment)) {
  
          const doorId = dockappointment[0]?.DockAppointment?.AssignedLocation?.Id ?? dockappointment[0]?.DockAppointment?.ScheduledLocation?.Id;
  
          if ($utils.isDefined(doorId)) {
              const dockDoor = (await $datasources.DockAppointments.ds_get_dock_door_by_locationId.get({ locationId: doorId })).result;
              if ($utils.isDefined(dockDoor)) {
                  // Get child location of type inventory
                  var locationId = dockDoor.ChildLocationContainers[0]?.Id
              }
  
          }
      }
  
      const dialogResult = await $shell.FootprintManager.openauto_load_options_formDialog({
          warehouseId: warehouseId,
          loadLocationId: locationId
      });
  
      var userConfirmed = dialogResult.confirm;
      var loadLocation = dialogResult.loadLocation;
  
      if ($utils.isDefined(userConfirmed) && userConfirmed === false) {
  
          return;
      }
      if (userConfirmed) {
          try {
  
              const result = await $flows.SalesOrders.auto_load_sales_order_flow({
                  orderId: $editor.entity.Id,
                  shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId,
                  loadLocation: loadLocation
              });
              const reason = result.reason;
  
              if ($utils.isDefined(reason)) {
                  await $shell.FootprintManager.openErrorDialog('Order cannot be fully auto loaded.', reason);
                  return;
              }
              else {
                  const title = `Order ${$editor.entity.LookupCode} loaded`;
                  $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
                  await $editor.refresh();
                  await $editor.tabs.shipping_contents.activate();
              }
  
          } catch (error) {
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
              await $shell.FootprintManager.openErrorDialog('Auto load order error', 'An error occurred during the auto loading of the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
          }
  
      }
  
  }
  }
  on_revert_clicked(event = null) {
    return this.on_revert_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_revert_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const result = await $flows.SalesOrders.is_sales_order_revertable_flow({
      orderId: $editor.entity.Id,
      shipmentId: $editor.vars.shipmentId
  });
  const reason = result.reason;
  if ($utils.isDefined(reason)) {
      await $shell.FootprintManager.openErrorDialog('Order cannot be reverted.', reason);
      return;
  } else {
      const confirm = await $shell.FootprintManager.openConfirmationDialog(`Revert order ${$editor.entity.LookupCode}?`, `This will bring the order back to the original created status`, 'Revert order', 'Cancel');
      if (confirm) {
          try {
              // Lock down buttons
              $editor.toolbar.revert.control.readOnly = true;
  
              const result = await $flows.SalesOrders.revert_sales_order_flow({
                  orderId: $editor.entity.Id,
                  shipmentId: $editor.vars.shipmentId
              });
              const reason = result.reason;
  
              if ($utils.isDefined(reason)) {
                  await $shell.FootprintManager.openErrorDialog('Order cannot be reverted.', reason);
                  $editor.toolbar.revert.control.readOnly = false;
                  return;
              }
              else {
                  const title = `Order ${$editor.entity.LookupCode} reverted`
                  $shell.FootprintManager.openToaster(title, '', EToasterType.Success, { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight });
                  
                  $editor.refresh();
                  await $editor.tabs.sales_order_lines.activate();
              }
          } catch (error) {
              $editor.toolbar.revert.control.readOnly = false;
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `Order ${$editor.entity.LookupCode} - ${errorMessage}`;
              await $shell.FootprintManager.openErrorDialog('Order revert error', 'An error occurred while reverting the order', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
          }
      }
  }
  }
  on_appointment_clicked(event = null) {
    return this.on_appointment_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_appointment_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const dockAppointments = (await $datasources.DockAppointments.ds_get_dock_appointment_by_orderId.get({
      orderId: $editor.inParams.orderId
  })).result;
  
  if ($utils.isDefined(dockAppointments)) {
  
      const dialogResult = await $shell.FootprintManager.opendock_appointment_editorDialog({
          dockAppointmentId: dockAppointments[0].DockAppointmentId
      },'flyout',EModalSize.Large)
  
  } else {
        // Check if the selected order is in a rejected status and throw an error.
      if ($editor.entity.OrderStatusId == 4096) {
  
          throw new Error('Selected order is currently in a rejected status, a dock appointment cannot be created against rejected orders.')
      }
  
      const nextAppointmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: 'DockAppointment' })).nextId;
  
      const dialogResult = await $shell.FootprintManager.opendock_appointment_creation_formDialog({
         
          warehouseId: [$editor.entity.PreferredWarehouseId],
          lookupcode: nextAppointmentId.toString(),
          scheduledArrival: $utils.isDefined($editor.entity.RequestedDeliveryDate) ? $editor.entity.RequestedDeliveryDate : $utils.date.now(),
          scheduledDeparture: $utils.isDefined($editor.entity.RequestedDeliveryDate) ? $utils.date.add(1, 'hour', $editor.entity.RequestedDeliveryDate) : $utils.date.add(1, 'hour', $utils.date.now()),
          typeId: 2,
          ownerId:  $editor.entity.Project.OwnerId,
          projectId: $editor.entity.ProjectId,
          carrierId: $editor.entity.PreferredCarrierId,
          orderId: $editor.inParams.orderId
      },'flyout',EModalSize.Large
  );
  
  }
  
  // Always refresh as the user might have made some changes to an existing address
  await $editor.refresh();
  
  }
  on_print_clicked(event = null) {
    return this.on_print_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_print_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  
  
  
  
  await $shell.SalesOrders.openload_slip_reportDialog({ orderId: $editor.inParams.orderId });
  }
  on_ship_to_cleared(event = null) {
    return this.on_ship_to_clearedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_ship_to_clearedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  const orderAddress = (await $flows.Addresses.create_generic_order_address_flow({ orderId: $editor.inParams.orderId }));
  if ($utils.isDefined(orderAddress)) {
  
      var accountId = orderAddress.accountId;
      var addressId = orderAddress.addressId;
  
  }
  
  if ($utils.isAllDefined(accountId, addressId)) {
  
  
      let payload: any = {};
  
      payload.AccountId = accountId;
      payload.BillingAddresId = addressId;
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: $editor.entity.Id, entity: payload });
  
  
  
      await $editor.refresh();
  
  
  }
  else {
  
      throw new Error('Unable to create clear selected ship to account.')
  }
  }
  apply_operations(event = null) {
    return this.apply_operationsInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async apply_operationsInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Processing.isAuthorized()) {
      $editor.toolbar.process.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Completion.isAuthorized()) {
      $editor.toolbar.complete.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_AutoPicking.isAuthorized()) {
      $editor.toolbar.auto_pick.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_AutoLoading.isAuthorized()) {
      $editor.toolbar.auto_load.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Cancellation.isAuthorized()) {
      $editor.toolbar.cancel.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Deletion.isAuthorized()) {
      $editor.toolbar.on_delete.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Reverting.isAuthorized()) {
      $editor.toolbar.revert.hidden = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrders_Copying.isAuthorized()) {
      $editor.toolbar.options.control.buttons.copy_order.readOnly = true;
  };
  
  if (await $operations.FootprintManager.Disable_Temperatures_Entry.isAuthorized()) {
      $editor.toolbar.options.control.buttons.temperature_readings.readOnly = true;
  };
  
  if (await $operations.FootprintManager.Disable_SalesOrder_Editing.isAuthorized()) {
  
      // Toolbar
      $editor.toolbar.appointment.hidden = true;
      $editor.toolbar.attachments.hidden = true;
      $editor.toolbar.auto_load.hidden = true;
      $editor.toolbar.auto_pick.hidden = true;
      $editor.toolbar.cancel.hidden = true;
      $editor.toolbar.complete.hidden = true;
      $editor.toolbar.on_delete.hidden = true;
      $editor.toolbar.process.hidden = true;
      $editor.toolbar.revert.hidden = true;
      $editor.toolbar.options.control.buttons.surveys.readOnly = true;
      $editor.toolbar.options.control.buttons.pallet_transactions.readOnly = true;
      $editor.toolbar.options.control.buttons.temperature_readings.readOnly = true;
  
  
      //Fields
  
      $editor.fields.bill_of_lading.control.readOnly = true;
      $editor.fields.carrier.control.readOnly = true;
      $editor.fields.carrier_service.control.readOnly = true;
      $editor.fields.container_identifier.control.readOnly = true;
      $editor.fields.custom_fields.control.readOnly = true;
      $editor.fields.expected_date.control.readOnly = true;
      $editor.fields.integration_information.control.readOnly = true;
      $editor.fields.lookupcode.control.readOnly = true;
      $editor.fields.notes.control.readOnly = true;
      $editor.fields.order_class.control.readOnly = true;
      $editor.fields.owner.control.readOnly = true;
      $editor.fields.pickup_date.control.readOnly = true;
      $editor.fields.project.control.readOnly = true;
      $editor.fields.reference.control.readOnly = true;
      $editor.fields.seal.control.readOnly = true;
      $editor.fields.ship_to_clear.control.readOnly = true;
      $editor.fields.ship_to_selection.control.readOnly = true;
      $editor.fields.tracking.control.readOnly = true;
      $editor.fields.trailer.control.readOnly = true;
      $editor.fields.vendor_reference.control.readOnly = true;
      $editor.fields.warehouse.control.readOnly = true;
  };
  }
  on_attachments_clicked(event = null) {
    return this.on_attachments_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_attachments_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //await $shell.FootprintManager.openentity_attachments_gridDialog({ entityType: 'Order', entityKeys: [{ name: 'Id', value: $editor.entity.Id }]});
  await $shell.FootprintManager.openorders_attachments_hubDialog({orderId: $editor.entity.Id, shipmentId: $editor.entity.ShipmentOrderLookups[0].ShipmentId},'flyout',EModalSize.Large
  )
  }
  on_surveys_clicked(event = null) {
    return this.on_surveys_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_surveys_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($editor.entity.ShipmentOrderLookups)) {
      await $shell.FootprintManager.opensubmitted_surveys_gridDialog({
          entities: [{ type: 'Shipment', ids: [$editor.entity.ShipmentOrderLookups[0].ShipmentId] }],
          operationContextTypes: null,
          warehouseIds: null
      }, 'flyout',EModalSize.Large );
  }
  
  
  }
  on_driver_check_out_clicked(event = null) {
    return this.on_driver_check_out_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_driver_check_out_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  // Open driver check out hub
  $shell.FootprintManager.opendriver_check_out_hub({
      orderId: $editor.inParams.orderId});
  }
  on_temperature_readings(event = null) {
    return this.on_temperature_readingsInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_temperature_readingsInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  $shell.FootprintManager.opentemperature_readings_gridDialog({
      orderId: $editor.inParams.orderId
  }, 'flyout', EModalSize.Xlarge);
  }
  on_custom_fields_clicked(event = null) {
    return this.on_custom_fields_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_custom_fields_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  await $shell.FootprintManager.openentity_user_defined_field_values_gridDialog({ entityType: 'Order', entityKeys: [{name: 'Id', value: $editor.inParams.orderId}]}, 'flyout', EModalSize.Xlarge);
  }
  on_discussions_clicked(event = null) {
    return this.on_discussions_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_discussions_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  await $shell.Discussions.opendiscussions_listDialog({
      entity_name: 'Order',
      entity_id: $editor.inParams.orderId.toString()
  },
  'flyout')
  
  $editor.refresh();
  }
  on_email_requests_clicked(event = null) {
    return this.on_email_requests_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_email_requests_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  await $shell.Notifications.openemail_requests_gridDialog({
      entityType: 'Order',
      entityId: $editor.entity.Id
  }, 'modal',EModalSize.Large);
  }
  on_integration_clicked(event = null) {
    return this.on_integration_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_integration_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 05/29/2024
  
  await $shell.FootprintManager.openintegration_info_by_order_idDialog({ order_id: $editor.inParams.orderId }, "flyout");
  }
  on_pallet_transactions_clicked(event = null) {
    return this.on_pallet_transactions_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_pallet_transactions_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/12/2024
  
  if ($utils.isDefined($editor.vars.shipmentId)) {
  
      await $shell.FootprintManager.openpallet_transactions_shipment_gridDialog({
          project_id: $editor.entity.ProjectId,
          shipment_id: $editor.vars.shipmentId,
          order_lookup_code: $editor.entity.LookupCode
      }, "flyout", EModalSize.Large)
  
  } else {
  
      await $shell.FootprintManager.openInfoDialog("Missing shipment!", "A shipment Id could not be found for this order!")
  }
  }
  on_so_print_labels(event = null) {
    return this.on_so_print_labelsInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_so_print_labelsInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $shell.FootprintManager.openprint_order_labels_formDialog({ orderId: $editor.entity.Id ,context:"so"});
  }
  on_copy_order_clicked(event = null) {
    return this.on_copy_order_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_copy_order_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  
  await $shell.FootprintManager.opensales_order_copy_formDialog({
      order_id: $editor.inParams.orderId
  },'modal');
  
  
  }
  on_convert_to_edi_clicked(event = null) {
    return this.on_convert_to_edi_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_convert_to_edi_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  const confirmEdi = await $shell.FootprintManager.openConfirmationDialog('Convert to EDI Order', `Are you sure you want to convert order  ${$editor.entity.LookupCode}?`, 'Yes', 'No');
  if (confirmEdi) {
      (await $flows.FootprintManager.convert_order_to_edi({ order_id: $editor.inParams.orderId }));
      $editor.on_init();
      $editor.refresh();
  }
  
  }
  on_instructions_clicked(event = null) {
    return this.on_instructions_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_instructions_clickedInternal(
    $editor: FootprintManager_sales_order_editorComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_sales_order_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $shell.FootprintManager.openinstructions_gridDialog(
    {
      entityName: 'Order',
      enabled: true,
      entityKey1:$editor.inParams.orderId,
      lookup_code:$editor.entity.LookupCode
    },
    'flyout',EModalSize.Xlarge
  );
  
  }
  //#endregion private flows
  
}
